import React, { useContext, useLayoutEffect, useRef } from "react";

import DownloadIcon from "../../../assets/img/card-icons/file_save.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./results.scss";
import CustomSelect from "../../common/customSelect";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import {
  CUSTOM_SELECT_COLOR_BLUE,
  CUSTOM_SELECT_COLOR_WHITE,
  CUSTOM_SELECT_COLOR_RED,
} from "../../common/customSelect/constants";

import ReactGA from "react-ga4";

import { useToggle } from "../../../hooks/useToggle";
import {
  ModalEmailComponent as EmailComponentSuccess,
  ModalEmailComponent as EmailComponentError,
} from "./email";
import { ModalVideoComponent } from "./video";
import { fetchLogs, myAxios } from "../../../utils/fetch";
import { TarjetaResultadosComponent } from "./tarjetaResultadosComponent";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { SwalMessage } from "../../../utils/sweet-alert/sweet-alert";
import { capitalize, toSentenceCase } from "../../../utils/capitalize";
import ViewIcon from "../../../assets/img/card-icons/previsualizar.svg";
import MailIcon from "../../../assets/img/card-icons/mail.svg";
import VideoIcon from "../../../assets/img/card-icons/video.svg";
import VideoDownloadIcon from "../../../assets/img/card-icons/descargar.svg";
import Tooltip from "@mui/material/Tooltip";
import { ModalDownloadMessageComponent } from "./download-message";
import { MessageContext } from "./download-message/Contex";

const DOWNLOAD_TIMEOUT_MS = 60000;

const ResultsComponent = () => {
  const { user } = useContext(UserGlobalContextMemorySpace);
  const [familyGroupList, setFamilyGroupList] = React.useState(null);
  const [year, setYear] = React.useState("Todos");
  const [limit, setLimit] = React.useState(5);
  const [offset, setOffset] = React.useState(0);
  const [service, setService] = React.useState("all");
  const [idSap, setIdSap] = React.useState(user.user.data.Customers.idSap);
  const [customers, setCustomers] = React.useState([user.user.data.Customers]);
  const [results, setResults] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const [loader, setLoader] = React.useState(true);
  const [familyItem, setFamilyItem] = React.useState(
    user.user.data.Customers.firstName + " " + user.user.data.Customers.lastName
  );
  const [serviceSelected, setServiceSelected] = React.useState(
    "Todos los resultados"
  );
  const [controllerAxios, setControllerAxios] = React.useState();

  const [closeAno, setCloseAno] = React.useState(false);
  const [closeFamily, setCloseFamily] = React.useState(false);
  const [closeService, setCloseService] = React.useState(false);

  const emailToggleSuccess = useToggle();
  const emailToggleError = useToggle();
  const videoToggle = useToggle();
  const downloadMessageToggle = useToggle();
  const [responseData, setResponseData] = React.useState({
    message: "",
    message2: "",
    icon: "success",
    buttonText: "Aceptar",
  });
  const [videoModalData, setVideoModalData] = React.useState({
    availableDays: "",
  });
  const [videoGenerating, setVideoGenerating] = React.useState(false);
  const [downloadingId, setDownloadingId] = React.useState(null);
  const downloadTimeoutRef = useRef(null);

  const refBusqueda = useRef();

  useLayoutEffect(() => {
    try {
      fetchLogs({
        idLogType: 1,
        idLog: 18,
        source: "hb-online",
        email: user.user.data.Customers.email,
        dni: user.user.data.Customers.dni ?? "",
        credencial: user.user.data.Customers.credencial ?? "",
        description:
          "El usuario " +
          user.user.data.Customers.lastName +
          " " +
          user.user.data.Customers.firstName +
          " accedió al área de laboratorio",
      });
    } catch (logError) {
      console.error("Error al acceder al área de laboratorio:", logError);
    }
  }, []);

  const obtenerResultados = (
    param_idSap,
    param_limit,
    param_offset,
    param_service,
    param_search,
    param_year
  ) => {
    setResults([]);
    setLoader(true);
    const payLoad = {
      dni: user.user.data.Customers.dni,
      email: user.user.data.Customers.email,
      idSap: param_idSap,
      limit: param_limit,
      offset: param_offset,
      service: param_service,
      search: param_search.trim(),
      idCustomer: user.user.data.Customers.idCustomer,
    };

    if (param_year !== "Todos") {
      payLoad.year = param_year;
    }

    let controller = new AbortController();
    setControllerAxios(controller);

    let endpoint =
      payLoad.service == "Otros Informes"
        ? "/patient/api/v1/results/laboratoryresultsother"
        : payLoad.service == "Medicina Nuclear"
        ? "/patient/api/v1/results/laboratoryresultsimg"
        : payLoad.service == "Diagnóstico por Imágenes"
        ? "/patient/api/v1/results/laboratoryresultsimg"
        : payLoad.service == "Laboratorio"
        ? "/patient/api/v1/results/laboratoryresultslab"
        : "/patient/api/v1/results/laboratoryresultsall";

    // if (payLoad.service === "Medicina Nuclear") {
    //   setTotal(0);
    //   setLoader(false);
    //   setResults([]);
    //   return;
    // }

    myAxios({
      signal: controller.signal,
      url: `${process.env.REACT_APP_GATEWAY_QA + endpoint}`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
      data: payLoad,
    })
      .then((response) => {
        setTotal(0);
        setLoader(false);

        let resultados = response.data.data.Results;

        resultados = resultados.filter((result) => {
          return payLoad.service == "all" || result.service == payLoad.service;
        });

        setResults(resultados);
        if (response.data.data.total > 0) {
          setTotal(response.data.data.total);
        }
      })
      .catch((error) => {
        setResults([]);
        setLoader(false);
        // console.log("ERRRRR",error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const onChangeYear = (id, name, text) => {
    setYear(id);
    setOffset(0);
    obtenerResultados(idSap, limit, 0, service, search, id);
  };

  const clickYear = () => {
    ReactGA.event({
      category: "Acciones-Resultados",
      action: "click",
      label: "anio-estudios",
    });
    setCloseFamily(true);
    setCloseService(true);
    setCloseAno(false);
  };

  React.useEffect(() => {
    myAxios({
      url:
        process.env.REACT_APP_GATEWAY_QA +
        "/customers/api/v1/familiargroup/getfamiliargroupbyid",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
      data: {
        idCustomer: user.user.data.Customers.idCustomer,
      },
    })
      .then((response) => {
        const familyGroup = response.data.data.FamilyGroup.map((family) => {
          return { id: family.idSap ?? "", name: capitalize(family.fullName) };
        });
        var temporalFamilyGroup = [
          {
            id: user.user.data.Customers.idSap,
            name:
              capitalize(user.user.data.Customers.firstName +
              " " +
              user.user.data.Customers.lastName),
          },
          ...familyGroup,
        ];
        setCustomers([...customers, ...response.data.data.FamilyGroup]);
        setFamilyGroupList(temporalFamilyGroup);
      })
      .catch((error) => {})
      .finally(() => {
        obtenerResultados(idSap, limit, offset, service, search, year);
      });
  }, []);

  React.useEffect(() => {}, [service, year, idSap, search, offset]);

  React.useEffect(() => {
    setOffset(0);
  }, [service, year, idSap, search]);

  //var defaultSelectText="Todos los resultados";
  var estudiosList = [
    { id: "all", name: "Todos los resultados" },
    { id: "Diagnóstico por Imágenes", name: "Diagnóstico por Imágenes" },
    { id: "Laboratorio", name: "Laboratorio" },
    { id: "Medicina Nuclear", name: "Medicina Nuclear" },
    { id: "Otros Informes", name: "Otros Informes" },
  ];

  const yearsList = (() => {
    const now = new Date();
    const year = now.getFullYear();
    const listaAnos = [{ id: "Todos", name: "Todos" }];
    const anos = year - 2017;

    for (var i = 0; i <= anos; i++) {
      listaAnos.push({ id: year - i, name: year - i });
    }

    return listaAnos;
  })();

  const changeService = (id, name, text) => {
    setService(id);
    setServiceSelected(text);
    setOffset(0);
    obtenerResultados(idSap, limit, 0, id, search, year);
  };

  const clickService = () => {
    ReactGA.event({
      category: "Acciones-Resultados",
      action: "click",
      label: "resultados-all",
    });
    setCloseFamily(true);
    setCloseService(false);
    setCloseAno(true);
  };

  const changeidSap = (id, name, text) => {
    setFamilyItem(text);
    setIdSap(id);
    setOffset(0);
    obtenerResultados(id, limit, 0, service, search, year);
  };

  const clickIdSap = () => {
    setCloseFamily(false);
    setCloseService(true);
    setCloseAno(true);
  };

  const searchData = (event) => {
    ReactGA.event({
      category: "Acciones-Resultados",
      action: "click",
      label: "Buscar",
    });

    let buscar = event.target.value;

    setSearch(buscar);
    setLoader(true);
    controllerAxios?.abort();
    setOffset(0);
    obtenerResultados(idSap, limit, 0, service, event.target.value, year);
  };

  const siguiente = () => {
    if (offset + limit > total) return;
    setOffset(offset + limit);
    obtenerResultados(idSap, limit, offset + limit, service, search, year);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Para un desplazamiento suave, si es compatible con el navegador
    });
  };

  const anterior = () => {
    const temporalOffset = offset - limit;
    if (temporalOffset < 0) return;
    setOffset(temporalOffset);
    obtenerResultados(idSap, limit, temporalOffset, service, search, year);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const mostrarMensajeDescarga = ({ message, message2, icon, buttonText }) => {
    setResponseData({
      message,
      message2,
      icon,
      buttonText,
    });
    downloadMessageToggle.setToggle(true);
  };

  const clearDownloadTimeout = () => {
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
      downloadTimeoutRef.current = null;
    }
  };

  const descargar = (resultado) => {
    if (downloadingId) return;

    setDownloadingId(resultado.idLaboratory);
    clearDownloadTimeout();
    downloadTimeoutRef.current = setTimeout(() => {
      mostrarMensajeDescarga({
        message: "Descargando...",
        message2:
          "La descarga está tardando más de lo esperado. Por favor, aguardá un momento o volvé a intentarlo más tarde.",
        icon: "loading",
        buttonText: "Continuar",
      });
    }, DOWNLOAD_TIMEOUT_MS);

    myAxios({
      url: resultado.links.urlDownload,
      headers: {
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    })
      .then((response) => {
        if (!response?.data?.data?.File) {
          mostrarMensajeDescarga({
            message: "No pudimos descargar el archivo",
            message2: "Por favor, intentá nuevamente más tarde.",
            icon: "error",
            buttonText: "Continuar",
          });
          return;
        }

        try {
          fetchLogs({
            idLogType: 1,
            idLog: 7,
            source: "hb-online",
            email: user.user.data.Customers.email,
            dni: user.user.data.Customers.dni ?? "",
            credencial: user.user.data.Customers.credencial ?? "",
            description:
              "El usuario " +
              user.user.data.Customers.lastName +
              " " +
              user.user.data.Customers.firstName +
              " bajó el informe resultado_" +
              resultado.idLaboratory,
          });
        } catch (logError) {
          console.error("Error al bajar el informe resultado:", logError);
        }

        const isSafariOnIOS = () => {
          const userAgent = navigator.userAgent;
          return (
            /iPhone|iPad|iPod/.test(userAgent) &&
            !/CriOS/.test(userAgent) &&
            /Safari/.test(userAgent)
          );
        };

        if (isSafariOnIOS()) {
          const byteCharacters = atob(response.data.data.File);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });

          // Crear un objeto URL para el blob
          const url = window.URL.createObjectURL(blob);

          // Crear un enlace y simular un clic para descargar el archivo
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.setAttribute(
            "download",
            `resultado_${resultado.idLaboratory}.pdf`
          );
          document.body.appendChild(downloadLink);
          downloadLink.download = `resultado_${resultado.idLaboratory}.pdf`;
          downloadLink.click();

          // Liberar el objeto URL creado
          window.URL.revokeObjectURL(url);
        } else {
          const linkSource = `data:application/pdf;base64,${response.data.data.File}`;
          const downloadLink = document.createElement("a");
          const fileName = `resultado_${resultado.idLaboratory}.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
        mostrarMensajeDescarga({
          message: "Descarga exitosa",
          message2: "El archivo se descargó correctamente.",
          icon: "success",
          buttonText: "Aceptar",
        });
      })
      .catch(() => {
        mostrarMensajeDescarga({
          message: "No pudimos descargar el archivo",
          message2: "Por favor, intentá nuevamente más tarde.",
          icon: "alert-info-red",
          buttonText: "Continuar",
        });
      })
      .finally(() => {
        clearDownloadTimeout();
        setDownloadingId(null);
      });
  };

  const verResultado = (resultado) => {
    console.log(resultado);
    var win = window.open(resultado.links.urlViewer, "_blank");
    win.focus();
  };

  const generarVideo = (resultado) => {
    if (resultado.videoStatus !== "GenerateVideo" || videoGenerating) return;

    setVideoGenerating(true);
    myAxios({
      url:
        process.env.REACT_APP_GATEWAY_2 +
        "/patient/api/v1/results/GenerateStudyVideo",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
      data: {
        accessionNumber: resultado.idLaboratory,
        description: resultado.description,
        idSap,
        idCustomer: user.user.data.Customers.idCustomer,
        firstName: user.user.data.Customers.firstName,
        lastName: user.user.data.Customers.lastName,
      },
    })
      .then((response) => {
        const apiResponse = response?.data ?? {};
        const data = apiResponse.data ?? {};

        if (apiResponse.Error || data.success === false) {
          SwalMessage(
            "info",
            "",
            data.message ||
              apiResponse.message ||
              "Se produjo un error al procesar la solicitud de generación de video.",
            "Continuar"
          );
          return;
        }

        setVideoModalData({
          availableDays: data.availableDays ?? "",
        });
        videoToggle.onToggle();
      })
      .catch(() => {
        SwalMessage(
          "info",
          "",
          "Se produjo un error al procesar la solicitud de generación de video.",
          "Continuar"
        );
      })
      .finally(() => {
        setVideoGenerating(false);
      });
  };

  const verVideo = (resultado) => {
    if (resultado.videoStatus !== "VideoComplete") return;

    myAxios({
      url:
        process.env.REACT_APP_GATEWAY_2 +
        `/patient/api/v1/results/GetStudyViewerUrl?accessionNumber=${resultado.idLaboratory}&idSap=${idSap}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    })
      .then((response) => {
        const url = response?.data?.data?.url;
        if (!url) {
          SwalMessage(
            "info",
            "",
            "Disculpe, no se pudo abrir el video. Por favor, intente nuevamente más tarde.",
            "Continuar"
          );
          return;
        }

        const win = window.open(url, "_blank");
        win?.focus();
      })
      .catch(() => {
        SwalMessage(
          "info",
          "",
          "Disculpe, no se pudo abrir el video. Por favor, intente nuevamente más tarde.",
          "Continuar"
        );
      });
  };

  const handleVideoClick = (resultado) => {
    if (videoGenerating) return;

    if (resultado.videoStatus === "GenerateVideo") {
      generarVideo(resultado);
      return;
    }

    if (resultado.videoStatus === "VideoComplete") {
      verVideo(resultado);
    }
  };

  const cerrarModalVideo = () => {
    videoToggle.onToggle();
    obtenerResultados(idSap, limit, offset, service, search, year);
  };

  const enviarEmail = (resultado) => {
    myAxios({
      url: resultado.links.urlSendEmail,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    })
      .then((response) => {
        if (!response.error) {
          emailToggleSuccess.onToggle();
        } else {
          emailToggleError.onToggle();
        }
      })
      .catch((error) => {});
  };

  const itemsPerPage = 5;
  const totalPages = Math.ceil(total / itemsPerPage);

  const handlePageChange = (event, page) => {
    const newOffset = (page - 1) * itemsPerPage;
    setOffset(newOffset);
    obtenerResultados(idSap, limit, newOffset, service, search, year);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const Desktop = () => {
    return (
      <>
        {/* SEPARADOR */}
        <div
          className="separador-table-red-result"
          id="separator-top-results"
        ></div>
        {/* TABLA */}
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="mb-4">
              {/* <span className="header-bold">Estudios de Imágenes: </span>
              <span className="header-regular">
                Recuerde que las imágenes estarán listas primero. El informe
                tomará de 7 a 10 días, según el estudio.
              </span> */}
              {(service === "Diagnóstico por Imágenes" ||
                service === "Medicina Nuclear" ||
                service === "all") && (
                <div className="mt-3 mb-1 info-imagenes-aviso">
                  <span className="header-bold">Estudios de Imágenes | </span>
                  <span className="header-regular">
                    Recuerde que las imágenes estarán disponibles primero, pero
                    el informe será visible luego, en el lapso normal de 7 a 10
                    días, según el tipo de estudio realizado.
                  </span>
                </div>
              )}
            </div>
            <div className="table-responsive" style={{ height: "265px" }}>
              {!loader ? (
                <table className="table table-hb" id="tableResults">
                  <thead>
                    <tr>
                      {results.length > 0 && (
                        <>
                          <th>Fecha</th>
                          <th>Estudio</th>
                          <th>Servicio</th>
                          <th>Acciones</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {results.length > 0 ? (
                      results.map((result) => {
                        const informeDisponible = result.links.urlDownload && result.idReport !== "";
                        const videoGenerable = result.videoStatus === "GenerateVideo";
                        const videoCompleto = result.videoStatus === "VideoComplete";
                        const videoAccionDisponible = videoGenerable || videoCompleto;
                        return (
                          <tr key={result.idLaboratory}>
                            <td>{result.dateDisplay}</td>
                            <td>{toSentenceCase(result.description)}</td>
                            <td>{result.service}</td>
                            <td>
                              {result.links.urlViewer ? (
                              <Tooltip title="Ver imágenes" placement="top" arrow>
                                <span>
                                  <img
                                    src={ViewIcon}
                                    alt="Ver resultado"
                                    className={`i-25-result ${result.links.urlViewer ? "pointer" : "disabled-resultados"}`}
                                    onClick={() => result.links.urlViewer && verResultado(result)}
                                  />
                                </span>
                              </Tooltip>
                              ) : (
                                <img
                                  src={ViewIcon}
                                  alt="Ver resultado"
                                  className="i-25-result disabled-resultados"
                                />
                              )}
                              <Tooltip placement="top" arrow
                                title={
                                  downloadingId === result.idLaboratory
                                    ? "Descargando"
                                    : informeDisponible ? (
                                    "Ver informe"
                                  ) : (
                                    <>
                                      <b>Ver informe</b>: será visible en el lapso normal de 7 a 10 días,
                                      según el tipo de estudio realizado.
                                    </>
                                  )
                                }
                              >
                                <span>
                                  {downloadingId === result.idLaboratory ? (
                                    <span
                                      className="result-icon-spinner"
                                      role="status"
                                      aria-label="Descargando"
                                    />
                                  ) : (
                                    <img
                                      src={DownloadIcon}
                                      alt="Descargar resultado"
                                      className={`i-25-result-download ${informeDisponible ? "pointer" : "disabled-resultados"}`}
                                      onClick={() => informeDisponible && descargar(result)}
                                    />
                                  )}
                                </span>
                              </Tooltip>
                              {result.links.urlSendEmail ? (
                              <Tooltip title="Enviar por E-mail" placement="top" arrow>
                                <span>
                                  <img
                                    src={MailIcon}
                                    alt="Enviar por email"
                                    className={`i-25-result ${result.links.urlSendEmail ? "pointer" : "disabled-resultados"}`}
                                    onClick={() =>
                                      result.links.urlSendEmail && enviarEmail(result)
                                    }
                                  />
                                </span>
                              </Tooltip>
                            ) : (
                              <img
                                src={MailIcon}
                                alt="Enviar por email"
                                className="i-25-result disabled-resultados"
                              />
                            )}
                              {videoAccionDisponible ? (
                              <Tooltip
                                placement="top"
                                arrow
                                title={videoGenerable ? "Generar video" : "Descargar video"}
                              >
                                <span>
                                  <img
                                    src={videoCompleto ? VideoDownloadIcon : VideoIcon}
                                    alt={videoGenerable ? "Generar video" : "Descargar video"}
                                    className={`i-25-result ${!videoGenerating ? "pointer" : "disabled"}`}
                                    onClick={() => handleVideoClick(result)}
                                  />
                                </span>
                              </Tooltip>
                            ) : (
                              <img
                                src={VideoIcon}
                                alt="Ver video"
                                className="i-25-result disabled"
                              />
                            )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <td
                        colSpan="5"
                        style={{
                          textAlign: "center",
                          paddingBottom: "15px",
                          paddingTop: "15px",
                        }}
                      >
                        <p
                          className="section_hb_title"
                          style={{
                            fontSize: "16px",
                          }}
                        >
                          No se encontraron resultados con esas opciones de
                          búsqueda.
                          <br /> Intente con otros parámetros, o contáctese con
                          nuestro equipo de{" "}
                          <a
                            href="mailto:soportewebhb@hbritanico.com.ar"
                            className="section_hb_title"
                            style={{
                              fontSize: "16px",
                              textDecoration: "underline",
                            }}
                          >
                            Soporte
                          </a>
                          .
                        </p>
                      </td>
                    )}
                  </tbody>
                </table>
              ) : (
                <div className="text-center" style={{ paddingBottom: "15px" }}>
                  <span className="spinner-grow spinner-grow-sm"></span>
                  <span className="spinner-grow spinner-grow-sm"></span>
                  <span className="spinner-grow spinner-grow-sm"></span>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* SEPARADOR */}
        <div className="separador-table-red-result"></div>
        {total > 0 && results.length > 0 && (
          <div className="row">
            <div className="col-12 d-flex justify-content-center my-3">
              <Stack spacing={2}>
                <Pagination
                  count={totalPages}
                  page={offset / itemsPerPage + 1}
                  onChange={handlePageChange}
                  showFirstButton={total > 5}
                  showLastButton={total > 5}
                  hidePrevButton={totalPages === 1}
                  hideNextButton={totalPages === 1}
                  color="primary"
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#E0E0E0", // gris claro
                      color: "#000", // texto negro
                      "&:hover": {
                        backgroundColor: "#d5d5d5",
                      },
                    },
                  }}
                />
              </Stack>
            </div>
          </div>
        )}
      </>
    );
  };

  const Mobile = () => {
    return (
      <>
        <div
          className="separador-table-red-result"
          style={{ marginBottom: "20px" }}
        ></div>

        {!loader ? (
          <div>
            {results.length > 0 ? (
              <div className="mt-2">
                {/* <div className="mb-5">
                  <span className="header-bold">Estudios de Imágenes: </span>
                  <span className="header-regular">
                    Recuerde que las imágenes estarán listas primero. El informe
                    tomará de 7 a 10 días, según el estudio.
                  </span>
                </div> */}
                {(service === "Diagnóstico por Imágenes" ||
                  service === "Medicina Nuclear" ||
                  service === "all") && (
                  <div className="mt-3 mb-1 info-imagenes-aviso mb-5">
                    <span className="header-bold">Estudios de Imágenes | </span>
                    <span className="header-regular">
                      Recuerde que las imágenes estarán disponibles primero,
                      pero el informe será visible luego, en el lapso normal de
                      7 a 10 días, según el tipo de estudio realizado.
                    </span>
                  </div>
                )}
                {results.map((result) => (
                  <TarjetaResultadosComponent
                    key={result.idLaboratory}
                    result={result}
                    estudio={result.description}
                    eventPreview={verResultado}
                    eventDownload={descargar}
                    eventMail={enviarEmail}
                    onVideoClick={handleVideoClick}
                    videoGenerating={videoGenerating}
                    downloadingId={downloadingId}
                  />
                ))}
              </div>
            ) : (
              <p
                className="section_hb_title"
                style={{
                  fontSize: "16px",
                  textAlign: "center",
                  paddingBottom: "15px",
                  paddingTop: "15px",
                }}
              >
                No se encontraron resultados con esas opciones de búsqueda.
                <br /> Intente con otros parámetros, o contáctese con nuestro
                equipo de{" "}
                <a
                  href="mailto:soportewebhb@hbritanico.com.ar"
                  className="section_hb_title"
                  style={{
                    fontSize: "16px",
                    textDecoration: "underline",
                  }}
                >
                  Soporte
                </a>
                .
              </p>
            )}
            {total > 0 && results.length > 0 && (
              <div className="row">
                <div className="col-12 my-3">
                  <div
                    style={{
                      overflowX: "auto",
                      display: "flex",
                      justifyContent: "center",
                      WebkitOverflowScrolling: "touch",
                      scrollbarWidth: "thin",
                      paddingBottom: "5px",
                    }}
                  >
                    <Stack spacing={2}>
                      <Pagination
                        count={totalPages}
                        page={offset / itemsPerPage + 1}
                        onChange={handlePageChange}
                        showFirstButton={total > 5}
                        showLastButton={total > 5}
                        hidePrevButton={totalPages === 1}
                        hideNextButton={totalPages === 1}
                        color="primary"
                        size="small"
                        siblingCount={1}
                        boundaryCount={1}
                        sx={{
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: "#E0E0E0", // gris claro
                            color: "#000", // texto negro
                            "&:hover": {
                              backgroundColor: "#d5d5d5",
                            },
                          },
                        }}
                      />
                    </Stack>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            className="text-center"
            style={{ paddingBottom: "15px", marginTop: "50px" }}
          >
            <span className="spinner-grow spinner-grow-sm"></span>
            <span className="spinner-grow spinner-grow-sm"></span>
            <span className="spinner-grow spinner-grow-sm"></span>
          </div>
        )}
      </>
    );
  };

  return (
    <MessageContext.Provider value={responseData}>
    <section className=" " ref={refBusqueda}>
      <ModalDownloadMessageComponent
        visible={downloadMessageToggle.toggle}
        onToggle={downloadMessageToggle.onToggle}
      />

      <EmailComponentSuccess
        visible={emailToggleSuccess.toggle}
        success={true}
        onToggle={emailToggleSuccess.onToggle}
      />

      <EmailComponentError
        visible={emailToggleError.toggle}
        success={false}
        onToggle={emailToggleError.onToggle}
      />

      <ModalVideoComponent
        visible={videoToggle.toggle}
        onToggle={cerrarModalVideo}
        availableDays={videoModalData.availableDays}
      />

      <div className="container p-4" id="container-resultados">
        {/* TITULO */}
        <div className="row container-label-results mb-3">
          <div className="col-lg-5">
            <h2 className="section_hb_title title-results">
              <b className="section_hb_title">Resultados de estudios</b>
            </h2>
          </div>

          <div className="col-lg-1"></div>
        </div>
        {/* SEPARADOR */}
        {/* <div className="separador-result"></div> */}

        <div className="row">
          <div className="item-1" id="findUserName">
            <div className="input-icons me-3" style={{ position: "relative" }}>
              <FontAwesomeIcon
                icon={faSearch}
                className="custom-icon-results"
              />
              <input
                className="input-field-results"
                type="text"
                placeholder="Buscar"
                onChange={searchData}
              />
            </div>
            <div>
              <div
                id="filterServices"
                className=""
                style={{ position: "relative" }}
              >
                <CustomSelect
                  width="200px"
                  defaultText={serviceSelected}
                  optionsList={estudiosList}
                  type={CUSTOM_SELECT_COLOR_RED}
                  name="services"
                  onChange={changeService}
                  onClick={clickService}
                  fontFamily="Roboto-Medium"
                  close={closeService}
                />
              </div>
            </div>
          </div>

          <div className="item-2 col-years-results">
            <div id="title-study-results" style={{ width: "112px" }}>
              <span className="año-estudio">Año del estudio</span>
            </div>
            <div style={{ position: "relative", width: "111px" }}>
              <CustomSelect
                close={closeAno}
                defaultText={year}
                optionsList={yearsList}
                type={CUSTOM_SELECT_COLOR_WHITE}
                onChange={onChangeYear}
                onClick={clickYear}
                width="111px"
                name="year"
                paddingTop="1rem"
                fontFamily="Roboto-Regular"
              />
            </div>
          </div>

          <div className="item-3" style={{ marginBottom: "0rem" }}>
            <div
              id="dropdown-name"
              style={{ position: "relative", maxWidth: "250px" }}
            >
              <CustomSelect
                defaultText={familyItem}
                optionsList={familyGroupList ?? [{ id: "", name: "" }]}
                type={CUSTOM_SELECT_COLOR_BLUE}
                width="100%"
                name="family"
                onChange={changeidSap}
                onClick={clickIdSap}
                fontFamily="Roboto-Regular"
                close={closeFamily}
              />
            </div>
          </div>
        </div>

        <div class="d-block d-md-none w-100" style={{ marginTop: "15px" }}>
          <Mobile />
        </div>

        {/* Componente para pantallas medianas y grandes (oculto en dispositivos móviles) */}
        <div class="d-none d-md-block w-100">
          <Desktop />
        </div>
      </div>
    </section>
    </MessageContext.Provider>
  );
};

export default ResultsComponent;
